module.exports = __webpack_public_path__ + "static/media/logo.f8e7af84.svg";